import { FormLabel, Grid, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const Superheroe = () => {

    const { setPromptData, promptData } = useActividadesContext();

    const handleSuperheroeChange = (event: any) => {
        const { value } = event.target;
        setPromptData((prevData: any) => ({
            ...prevData,
            superheroe: value
        }));
    };


    return (
        <Grid xs={12} lg={12} md={12}>
            <Typography id="modal-modal-title" sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }} >
                Personaje y superheroe que quiero *
            </Typography>
            <FormLabel sx={{ fontFamily: 'montserrat', fontSize: '0.85rem' }}>Detalla las características de un Personaje o superheroe que quieres y/o deben ser considerados. </FormLabel>
            <TextField
                required
                id="contexto"
                placeholder='Ejemplo: Super heroes de comics Marvel.'
                name="contexto"
                fullWidth
                autoComplete="given-name"
                variant="outlined"
                value={promptData.superheroe}
                onChange={handleSuperheroeChange}
                InputProps={{
                    sx: {
                        borderRadius: 2,
                        mt: 1,
                        mb: 3,
                        fontFamily: 'montserrat',
                        fontSize: '0.75rem',
                        color: '#005559',
                        '&::placeholder': {
                            color: '#005559',

                        },
                        '&:before': {
                            borderBottomColor: '#005559',

                        },
                        '&:after': {
                            borderBottomColor: '#005559',
                        },
                    }
                }}
            />
        </Grid>
    );
};

export default Superheroe;




